<h2>Sessions</h2>
<section class="sessions mat-elevation-z3">
  <table mat-table [dataSource]="isLoading ? skeletonData : sessionDataSource">
    <ng-container matColumnDef="ip">
      <th mat-header-cell *matHeaderCellDef [attr.data-testid]="testIds.ipHeader">IP-Adresse</th>
      <td mat-cell *matCellDef="let element" [attr.data-testid]="testIds.ipData">
        @if (isLoading) {
          <ngx-skeleton-loader count="1"></ngx-skeleton-loader>
        } @else {
          <span>{{ element.ip }}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="lastSeen">
      <th mat-header-cell *matHeaderCellDef [attr.data-testid]="testIds.lastSeenHeader">Zuletzt gesehen</th>
      <td mat-cell *matCellDef="let element" [attr.data-testid]="testIds.lastSeenData">
        @if (isLoading) {
          <ngx-skeleton-loader count="1"></ngx-skeleton-loader>
        } @else {
          <span> {{ element.last_seen | date: 'dd.MM.yyyy, HH:mm:ss' }}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="useragent">
      <th mat-header-cell *matHeaderCellDef [attr.data-testid]="testIds.userAgentHeader">Useragent</th>
      <td mat-cell *matCellDef="let element" [attr.data-testid]="testIds.userAgentData">
        @if (isLoading) {
          <ngx-skeleton-loader count="1"></ngx-skeleton-loader>
        } @else {
          <span>{{ element.user_agent }}</span>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row no-data" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <span>Keine Sessions vorhanden.</span>
      </td>
    </tr>
  </table>
</section>
